import { clsx, type ClassValue } from 'clsx';

// NOTE: intentionally plain clsx, NOT tailwind-merge. Conflicting utilities are
// not de-duplicated, so a later className does not reliably override an earlier
// base utility on the same CSS property (the compiled-CSS source order decides
// the winner). When you need a guaranteed override of a base utility, use an
// inline `style` or a `!` important modifier rather than relying on class
// precedence. See Button.tsx for the canonical example of this gotcha.
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
